<lib-vitu-tooltip *ngIf="isLocked" text="Locked">
    <i class="fas fa-lock global-table-cell-image-only user-status-locked"></i>
</lib-vitu-tooltip>
<lib-vitu-tooltip *ngIf="!isLocked" text="Unlocked">
    <i class="far fa-lock-open global-table-cell-image-only user-status-unlocked"></i>
</lib-vitu-tooltip>
